export default __webpack_public_path__ + "static/media/eclipse-tool.a44b4782.jpg";